export default __webpack_public_path__ + "static/media/cancel.2c9dc689.svg";